import model from "@/model";
import emUtils from "@/utils/emUtils";

export default {
    props: {
        //指定vuex中用来保存数据的entity对象，及model中该entity的configs
        $_emCustomVuexMixin_entity: {
            type: String,
            default: 'entity'
        },
        //指定vuex中用来查询的filter对象，及model中该filter的configs
        $_emCustomVuexMixin_filter: {
            type: String,
            default: 'filter'
        },
        //指定vuex中用来存储查询结果的voList对象，及model中该vo的configs
        $_emCustomVuexMixin_vo: {
            type: String,
            default: 'rows'
        },
        //如果需要在新增修改页面展示的不一样，需要这里改true
        $_need_storeEntity :{
            type: Boolean,
            default: false
        },
    },
    computed: {
        $_emCustomVuexMixin_needToRefresh: {
            get() {
                return this.$store.state[this.entity].needToRefresh
            },
            set(value) {
                this.$store.commit(`${this.entity}/setNeedToRefresh`, value)
            }
        },
        $_emCustomVuexMixin_filterConfigs() {
            let filterConfigs = this.$_emCustomVuexMixin_filter === "filter"
                ? "filterConfigs" : `${this.$_emCustomVuexMixin_filter}Configs`
            console.log('filterConfigs', filterConfigs)
            console.log('filterConfigs', model[this.entity][filterConfigs])

            return model[this.entity][filterConfigs]
        },
        $_emCustomVuexMixin_entityConfigs() {
            let entityConfigs = this.$_emCustomVuexMixin_entity === "entity"
                ? "entityFormConfigs" : `${this.$_emCustomVuexMixin_entity}Configs`
            return model[this.entity][entityConfigs]
        },
        $_emCustomVuexMixin_voConfigs() {
            return this.$_emCustomVuexMixin_vo === "rows"
                ? model[this.entity].gridFields()
                : model[this.entity][`${this.$_emCustomVuexMixin_vo}Configs`]
        },
        $_emCustomVuexMixin_voName() {
            return this.$_emCustomVuexMixin_vo === "rows"
                ? null
                :`${this.$_emCustomVuexMixin_vo}Configs`
        },
        $_emCustomVuexMixin_filterStore: {
            get() {
                return this.$store.state[this.entity][this.$_emCustomVuexMixin_filter]
            },
            set(value) {
                this.$store.commit(`${this.entity}/set${emUtils.toCapFirst(this.$_emCustomVuexMixin_filter)}`, value)
            }
        },
        $_emCustomVuexMixin_entityStore: {
            get() {
                if (this.$_need_storeEntity) {
                    return this.$store.state[this.entity]['entity']
                }
                return this.$store.state[this.entity][this.$_emCustomVuexMixin_entity]
            },
            set(value) {
                console.log("set{}",this.$store.state[this.entity]);
                this.$store.commit(`${this.entity}/set${emUtils.toCapFirst(this.$_emCustomVuexMixin_entity)}`, value)
            }
        },
        $_emCustomVuexMixin_voStore: {
            get() {
                return this.$store.state[this.entity][this.$_emCustomVuexMixin_vo]
            },
            set(value) {
                this.$store.commit(`${this.entity}/set${emUtils.toCapFirst(this.$_emCustomVuexMixin_vo)}`, value)
            }
        },
        $_emCustomVuexMixin_checkItems() {
            return this.$_emCustomVuexMixin_vo === "rows"
                ? this.$store.state[this.modelName].checkedItems
                : this.$store.state[this.modelName][`checkedItems${emUtils.toCapFirst(this.$_emCustomVuexMixin_vo)}`]
        },
        $_emCustomVuexMixin_rows() {
            return this.$_emCustomVuexMixin_vo === "rows"
                ? this.$store.state[this.modelName].rows
                : this.$store.state[this.modelName][this.$_emCustomVuexMixin_vo]
        },
        selectedNotEqualOne() {
            return this.$_emCustomVuexMixin_checkItems.length !== 1
        },
        notSelected() {
            return this.$_emCustomVuexMixin_checkItems.length < 1
        },
        selectedItems() {
            return this.$_emCustomVuexMixin_rows.filter(row => this.$_emCustomVuexMixin_checkItems.indexOf(row.id) !== -1)
        },
    },
    methods: {
        $_emCustomVuexMixin_setFilterAttribute(key, newValue) {
            this.$store.commit(`${this.entity}/set${emUtils.toCapFirst(this.$_emCustomVuexMixin_filter)}Attribute`, {
                key,
                newValue
            })
        },
        $_emCustomVuexMixin_setEntityAttribute(key, newValue) {
            this.$store.commit(`${this.entity}/set${emUtils.toCapFirst(this.$_emCustomVuexMixin_entity)}Attribute`, {
                key,
                newValue
            })
        },
        $_emCustomVuexMixin_newEntity() {
            return model[this.entity].newEntity();
        }
    }
};
